import { v_DispatchNoteBus } from './v_DispatchNoteBus';
import { v_DispatchAttachmentBus } from './v_DispatchAttachmentBus';
import { BaseBus } from './BaseBus';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';

export class AdditionalCnstContractData extends BaseBus
{
    constructor(data: AdditionalCnstContractData = null) {
        super(data);
        if (CommonFunctions.hasValue(data)) {
            if (CommonFunctions.hasArrayValue(data.dispatchNotes)) {
                let notes: v_DispatchNoteBus[] = [];
                let notesInjury: v_DispatchNoteBus[] = [];
                for (let i = 0; i < data.dispatchNotes.length; i++) {
                    let newData: v_DispatchNoteBus = new v_DispatchNoteBus(data.dispatchNotes[i]);
                    if (newData.isWarning) {
                        notesInjury.push(newData);
                    }
                    else {
                        notes.push(newData);
                    }
                }
                this.dispatchNotes = notes;
                this.dispatchNotesInjury = notesInjury;
            }
            this.acctMgr = data.acctMgr;
            this.invoiceNumber = data.invoiceNumber;
            this.quoteNumber = data.quoteNumber;
        }
    }
    clear() {
        this.acctMgr = "";
        this.quoteNumber = "";
        this.invoiceNumber = "";
        this.profit1 = null;
        this.profit2 = null;
        this.dispatchNotes = null;
        this.dispatchNotesInjury = null;
        this.dispatchAttachments = null;
        this.dispatchAttachmentDetails = null;
    }
  acctMgr: string = "";
  quoteNumber: string = "";
  invoiceNumber: string = "";
  profit1: number;
  profit2: number;
    dispatchNotes: v_DispatchNoteBus[];
    dispatchNotesInjury: v_DispatchNoteBus[];
  dispatchAttachments: v_DispatchAttachmentBus[];
    dispatchAttachmentDetails: v_DispatchAttachmentBus[];
    //get dispatchNotesNonInjury(): v_DispatchNoteBus[] {
    //    let notes: v_DispatchNoteBus[] = [];
    //    if (CommonFunctions.hasArrayValue(this.dispatchNotes)) {
    //        return this.dispatchNotes.filter(x => x.isWarning === false);
    //    }
    //}
    //get dispatchNotesInjury(): v_DispatchNoteBus[] {
    //    let notes: v_DispatchNoteBus[] = [];
    //    if (CommonFunctions.hasArrayValue(this.dispatchNotes)) {
    //        return this.dispatchNotes.filter(x => x.isWarning === true);
    //    }
    //}
}
